import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getNativeLocalPath } from 'utils/conversion'
import { encryptAudioFile, decryptAudioFile, removeFile } from 'utils/cordovaFs'

import { t } from 'translation'

import Spinner from 'components/ui/Spinner/Spinner'

const UpdateSongMobilePage = ({ downloadedSongs, attributes, isDoctor, isPro }) => {
  const [scaleClassIsSet, setScaleClassIsSet] = useState(false)

  const history = useHistory()

  const encrypt = async () => {
    for (const song of downloadedSongs) {
      const input = await getNativeLocalPath(`songs/song_${song}.mp3`)
      const output = input.replace('mp3', 'mc')
      await encryptAudioFile(input, output)
      await removeFile(`song_${song}.mp3`)
    }

    window.cordova.plugins.foregroundService.stop()

    const showWelcomeVideo = attributes?.permissions?.features?.alwaysOnWelcomeVideo
    const redirectPath =
      showWelcomeVideo && !isDoctor
        ? `/welcome`
        : isDoctor
        ? `/welcome-doctor`
        : '/indication-select'

    history.push(redirectPath)
  }

  const decrypt = async () => {
    for (const song of downloadedSongs) {
      const input = await getNativeLocalPath(`songs/song_${song}.mc`)
      const output = input.replace('mc', 'mp3')
      await decryptAudioFile(input, output)
      await removeFile(`song_${song}.mc`)
    }

    localStorage.setItem('songsInitialized', false)
    window.cordova.plugins.foregroundService.stop()

    const showWelcomeVideo = attributes?.permissions?.features?.alwaysOnWelcomeVideo
    const redirectPath =
      showWelcomeVideo && !isDoctor
        ? `/welcome`
        : isDoctor
        ? `/welcome-doctor`
        : '/indication-select'

    history.push(redirectPath)
  }

  useEffect(() => {
    document.documentElement.classList.add('no_scale_mod')
    setScaleClassIsSet(true)

    window.cordova.plugins.foregroundService.start(
      t('notification.TITLE'),
      t('notification.DESCRIPTION_UPDATE'),
      'drawable-ldpi-icon'
    )

    const update = async () => {
      if (!isPro) await encrypt()
      else await decrypt()
    }

    update()
  }, [])

  return (
    <section className="section login_mod">
      {scaleClassIsSet && (
        <>
          <div className="section_in login_mod">
            <div className="tab_content_wrap welcome_block">
              <div className="auth_block_update offset_mod center_lvl_mod">
                <Spinner className="spinner_button" />
                <p>{t('settings.UPDATE_INFO')}</p>
                <p>{t('settings.UPDATE_DEVICE')}</p>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  )
}

const mapStateToProps = ({
  auth: { attributes, isDoctor, isPro },
  download: { downloadedSongs },
}) => {
  return {
    attributes,
    isDoctor,
    isPro,
    downloadedSongs,
  }
}

export default connect(mapStateToProps)(UpdateSongMobilePage)
